import { render, staticRenderFns } from "./comeOn.vue?vue&type=template&id=eb12cec8&scoped=true"
import script from "./comeOn.vue?vue&type=script&lang=js"
export * from "./comeOn.vue?vue&type=script&lang=js"
import style0 from "./comeOn.vue?vue&type=style&index=0&id=eb12cec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb12cec8",
  null
  
)

export default component.exports